import { render, staticRenderFns } from "./webview.vue?vue&type=template&id=b46055a6&scoped=true&"
import script from "./webview.vue?vue&type=script&lang=js&"
export * from "./webview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b46055a6",
  null
  
)

export default component.exports